module.exports = __webpack_public_path__ + "img/gonetworksj1.29b078a3.png";